import React from "react";

function SectionAbout() {
  return (
    <div>
      <section className="section-about">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="mt-4 text-center wow animate__animated animate__fadeInDown">
                من نحن
              </h1>
              <hr className="m-auto mt-2" />
            </div>
            <div className="col-6 my-5">
              <img
                className="w-100 rounded wow animate__animated animate__fadeInLeft"
                src="/img/WhatsApp Image 2026-01-05 at 5.55.27 PM (2).jpeg"
                alt=""
              />
            </div>
            <div className="col-6 my-5" dir="rtl">
              <p className="wow animate__animated animate__fadeInRight">
                شركة سوفت تريد
                <span className="text-dark">
                  تقدم لكم منتج شيبسي مصنوع من أجود أنواع البطاطس المزروعة
                  بعناية فائقة في أحواض زراعية خاصة، مع استخدام الأسمدة
                  الأورجانيك لنضمن منتجًا آمنًا وصحيًا لجميع الأعمار. و حاصلون
                  على جميع شهادات{" "}
                </span>
                الجودة الأوروبية، السعودية، والأمريكية
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SectionAbout;
